<template>
    <div style="padding: 20px; overflow: auto; height: 100%">
        <!-- <div style="text-align: center;font-size: 24px;height: 60px;line-height: 60px;"> 会议议题 </div> -->
        <div class="home">
            <div style="margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center">
                <div>
                    <el-checkbox v-text-lbl="'hygl.hyyt.messageReminder'" :value="vo.isMessage === 1" @change="toggleChecked">消息提醒</el-checkbox>
                </div>
                <div>
                    <el-button-group>
                        <el-button v-if="canEdit" v-text-lbl="'hygl.components.selectMeeting'" icon="el-icon-document" @click="clickSelectFn">选择议题</el-button>
                        <el-button v-if="canEdit" v-pageBtn-lbl="'del'" icon="el-icon-close" @click="deleteAllFn">删除</el-button>
                        <el-button v-pageBtn-lbl="'export'" icon="el-icon-top" @click="exportWformFn">导出</el-button>
                    </el-button-group>
                </div>
            </div>
            <el-table v-if="isTableShow" :data="tableData" border row-key="date" class="draggable-table" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection" width="55"></el-table-column>
                <el-table-column type="index" :label="$tx('fields.index', '序号')" width="50" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.$index + 1 }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="subject" :label="$tx('hygl.components.meetingAgenda', '会议议题')"></el-table-column>
                <el-table-column prop="mainDept" :label="$tx('hygl.components.hostDepartment', '主办部门')" width="100" align="center"></el-table-column>
                <el-table-column prop="reportPersonName" :label="$tx('hygl.components.declarant', '陈述人')" width="90" align="center"></el-table-column>
                <el-table-column prop="startTime" :label="$tx('hygl.components.startTime', '开始时间')" width="230" align="center">
                    <template slot-scope="scope">
                        <div>
                            <el-date-picker v-if="canEdit" v-model="scope.row.startTime" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$tx('hygl.hyyt.selectStartTime', '选择开始时间')" @change="valueChange($event, scope.row, scope.$index)"></el-date-picker>
                            <div v-else>
                                {{ timeFormat(scope.row.startTime) }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="reportTime" :label="$tx('hygl.components.csTime', '陈述时间/分钟')" width="110" align="center"></el-table-column>
                <el-table-column prop="talkTime" :label="$tx('hygl.components.talkTime', '讨论时间/分钟')" width="110" align="center"></el-table-column>
                <el-table-column prop="attendDept" :label="$tx('hygl.components.attendDept', '列席部门')" width="130" align="center"></el-table-column>
                <el-table-column prop="resolution" :label="$tx('hygl.components.resolution', '决策建议')" width="200" align="left"></el-table-column>
                <el-table-column prop="status" :label="$tx('hygl.components.status', '状态')" width="80" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.status == 0 ? $tx('hygl.components.noMeeting', '未上会') : scope.row.status == 1 ? $tx('hygl.components.onMeeting', '已上会') : $tx('hygl.components.waitMeeting', '待上会') }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="" :label="$tx('hygl.components.attach', '附件')" width="70" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.passenger.attachments.length }}</div>
                    </template>
                </el-table-column>

                <el-table-column v-if="canEdit" prop="orderNo" :label="$tx('hygl.components.order', '排序')" width="80" align="center">
                    <template slot-scope="scope">
                        <div style="display: flex; justify-content: center" class="handle">
                            <i style="font-size: 18px" class="el-icon-rank"></i>
                            <span v-text-lbl="'move'">移动</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="canEdit" prop="caozuo" :label="$tx('pageBtns.operate', '操作')" width="100" align="center">
                    <template slot-scope="scope">
                        <div style="display: flex; justify-content: space-evenly; color: #1a82e3">
                            <span v-pageBtn-lbl="'edit'" @click="editFn(scope.row)">编辑</span>
                            <span v-pageBtn-lbl="'del'" @click="delFn(scope.row)">删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <Basicform :title="$tx('hygl.hyyt.ytkTitle', '议题库')" :win-width="moduleInfo.winWidth" :win-height="moduleInfo.winHeight" :append-to-body="true" :toolbar-btns="busiformBtns" :on-basic-form-submited="onBasicFormSubmited" :module-code="moduleInfo.moduleCode">
                <template #default="slotProps">
                    <busi-form ref="ytk" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
                </template>
            </Basicform>

            <el-dialog :title="$tx('common.operationTip', '操作提示')" :visible.sync="ytmuShow" width="800px">
                <div>
                    <el-form>
                        <div style="width: 100%" class="el-table el-table--fit el-table--border">
                            <div class="el-table__body-wrapper">
                                <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                                    <tbody>
                                        <tr>
                                            <td ref="tdlbl_会议目录 " class="el-table__cell tdlbl tdw17" colspan="1">
                                                <span class="required">*</span>
                                                <span v-field-lbl="'meetShape'" class="field">选择会议目录</span>
                                            </td>
                                            <td class="el-table__cell tdcont tdw83" colspan="2">
                                                <el-select v-model="selectHyml" style="width: 100%" placeholder="请选择">
                                                    <el-option v-for="item in ytList" :key="item.id" :label="item.text" :value="item.id"></el-option>
                                                </el-select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button v-pageBtn-lbl="'cancel'" @click="ytmuShow = false">取 消</el-button>
                    <el-button v-pageBtn-lbl="'sure'" type="primary" @click="selecthyytFn">确 定</el-button>
                </span>
            </el-dialog>
            <YtRecordDialog @selectSubmit="selectSubmit" />
        </div>
    </div>
</template>

<script>
import Sortable from 'sortablejs'
import YtRecordDialog from './ytRecordDialog.vue'
const moment = require('moment')
export default {
    components: {
        YtRecordDialog
    },
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        wfInstance: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 }
    },
    data() {
        return {
            dialogVisible: false,
            tableData: [],
            row: {},
            moduleInfo: {
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/hygl/ytRecord/form.html',
                winWidth: 1200,
                delUrl: '/hygl/ytRecord/delete',
                addNewUrl: '/hygl/ytRecord/addNew',
                insertUrl: '/hygl/ytRecord/insert',
                moduleCode: 'budgetKpi',
                winHeight: 600,
                updateUrl: '/hygl/hyapYtInfo/update',
                listDataUrl: '/hygl/hyapYtInfo/listdata',
                getByIdUrl: '/hygl/hyapYtInfo/getById'
            },
            busiformBtns: [],
            isChange: false,
            isTableShow: true,
            xxtxChecked: false,
            selectList: [],
            ytList: [],
            selectHyml: '',
            ytmuShow: false,
            autoCompute: true // 是否自动计算开始时间
        }
    },
    computed: {},
    watch: {},
    created() {
        this.openFn()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        toggleChecked() {
            this.vo.isMessage = (this.vo.isMessage + 1) % 2
        },
        handleSelectionChange(list) {
            this.selectList = list
        },
        deleteAllFn() {
            if (this.selectList.length > 0) {
                const ids = []
                this.selectList.forEach((item) => {
                    ids.push(item.id)
                })
                this.$http({
                    method: 'delete',
                    url: '/hygl/hyapYtInfo/delete',
                    params: {
                        ids: ids.join(',')
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.autoCompute = true
                        this.getListData(this.vo, true)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            } else {
                this.$message.warning(this.$tx('hygl.message.selectData', '请先选择数据！'))
            }
        },
        exportWformFn() {
            if (!this.tableData.length) {
                this.$alert(this.$tx('hygl.message.noMeetingTitle', '暂无会议议题。'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                return
            }
            const headerAlias = {
                subject: '会议议题',
                mainDept: '主办部门',
                reportPersonName: '陈述人',
                startTime: '开始时间',
                reportTime: '陈述时间/分钟',
                talkTime: '讨论时间/分钟',
                attendDept: '列席部门',
                status: '状态'
            }

            console.log('JSON.stringify(headerAlias)', JSON.stringify(headerAlias))
            window.open(`/apigw/hygl/hyapYtInfo/dynamicExportData?pageNum=1&pageSize=9999&orderBy=orderNo&urlsearch=hyapId:${this.vo.id}&headerAlias=${encodeURIComponent(JSON.stringify(headerAlias))}&fileName=${encodeURIComponent('会议议题.xlsx')}`)
            // this.$http({
            //     method: 'post',
            //     url: 'hygl/vwHyglMeetDirectoryYtRecord/dynamicExportData',
            //     params: {
            //         fileName: '会议议题'

            //     },
            //     data: {
            //         pager: {
            //             pageSize: 9999,
            //             pageNum: 1,
            //             urlsearch: 'hyapId:48b1374517594a2294c99faa5d394d19',
            //             orderBy: 'orderNo asc'
            //         },
            //         headerAlias: {
            //             '会议议题': 'subject',
            //             '主办部门': 'mainDept'
            //         }
            //     }
            // }).then(res => {
            //     console.log('res', res)
            //     console.log(res instanceof Blob)
            //     const blobUrl = URL.createObjectURL(res)

            //     const link = document.createElement('a')
            //     link.href = blobUrl
            //     link.download = 'desired_filename.ext' // 替换为实际文件名和扩展名
            //     document.body.appendChild(link) // 需要插入文档以触发 click 事件
            //     link.click()
            //     document.body.removeChild(link) // 下载完成后移除元素
            // })
        },
        saveChange() {
            if (this.isChange) {
                this.$http({
                    method: 'post',
                    url: '/hygl/meetDirectoryYtRecord/modifyOrderNo',
                    data: this.tableData
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.dialogVisible = false
                    } else {
                        this.$message.error(res.message)
                    }
                })
            } else {
                this.dialogVisible = false
            }
        },
        clickSelectFn() {
            this.selectHyml = ''
            this.ytList = []
            if (this.vo.ytObject && this.vo.ytId) {
                if (this.vo.ytId.indexOf(',') > -1) {
                    const arr = this.vo.ytObject.split(',')
                    const ids = this.vo.ytId.split(',')
                    ids.forEach((item, index) => {
                        this.ytList.push({ text: arr[index], id: item })
                    })
                } else {
                    this.ytList = [{ text: this.vo.ytObject, id: this.vo.ytId }]
                }
            } else {
                this.$alert(this.$tx('hygl.message.selectMeetingMenu', '请选择会议目录。'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                return
            }

            // this.ytmuShow = true

            this.$bus.emit('openYtRecordDialog', this.vo, this.tableData, 'meetDirectoryYtRecordId', this.ytList)
        },
        selecthyytFn() {
            if (!this.selectHyml) return this.$message.warning(this.$tx('hygl.message.selectMeetingMenu', '请选择会议目录。'))
            this.ytmuShow = false
            // const ids = []
            // this.tableData.forEach(item => {
            //     if (item.meetDirectoryYtRecordId) {
            //         ids.push(item.meetDirectoryYtRecordId)
            //     }
            // })
            // var el = {
            //     attrs: {
            //         'listviewurl': `hygl.ytRecord.list?urlsearch=meetDirectoryYtRecordId!:${ids.join(',')};subjectTypeName:${this.vo.meetingTypeName}`,
            //         'dialog-title': '选择议题',
            //         'exclude-fields': '',
            //         'retain-btns': 'addObject,editObject',
            //         'multiple': true
            //     }
            // }
            // const vnode = {
            //     context: this,
            //     'data': { model: { expression: '' }}
            // }
            // this.$bus.emit('openListpageDialog', el, null, vnode)
            this.$bus.emit('openYtRecordDialog', this.vo, this.tableData, 'meetDirectoryYtRecordId')
        },
        selectSubmit(list, dirId, callback) {
            const ids = []
            list.forEach((item) => {
                ids.push(item.id)
            })
            if (ids.length > 0) {
                this.$http({
                    method: 'post',
                    url: '/hygl/hyapYtInfo/relevanceYtRecord',
                    params: {
                        hyapId: this.vo.id,
                        // meetDirectoryId: this.selectHyml,
                        meetDirectoryId: dirId,
                        ytRecordLists: ids.join()
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.autoCompute = true
                        this.getListData(this.vo, true)
                        callback()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
        // 通用列表选择对话框-选择数据后回调
        onSelectListpageRowCompleted(selectedRows, attr) {
            console.log(attr.listviewurl, 'onSelectListpageRowCompleted')
            const ids = []
            selectedRows.forEach((item) => {
                ids.push(item.id)
            })
            if (ids.length > 0) {
                this.$http({
                    method: 'post',
                    url: '/hygl/hyapYtInfo/relevanceYtRecord',
                    params: {
                        hyapId: this.vo.id,
                        meetDirectoryId: this.selectHyml,
                        ytRecordLists: ids.join()
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.autoCompute = true
                        this.getListData(this.vo, true)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
        /**
         * 基本表单提交完成，vo为已保存成功的calendar对象，窗口即将关闭，不需要返回值
         */
        onBasicFormSubmited: function ($scope, vo) {
            console.log('calendar form submited', this.moduleInfo.isShengcheng)
            if (this.moduleInfo.isShengcheng) {
                this.$http({
                    method: 'post',
                    url: '/hygl/meetDirectoryYtRecord/relevance',
                    params: {
                        meetDirectoryId: this.row.id,
                        ytRecordIds: vo.id
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.$message.success(res.message)
                        this.autoCompute = true
                        this.getListData(this.row, true)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }
        },
        addFormFn() {
            this.moduleInfo.isShengcheng = true
            this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/hygl.ytRecord.form.vue?sysCode=' + this.$route.meta.sysCode
            this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfo.formTemplate)
            this.busiformBtns = []
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, null, 1, (res) => {
                    this.moduleInfo.isShengcheng = false
                })
            })
        },
        editFn(row) {
            const _this = this
            this.moduleInfo.formTemplate = '#/dcontent/vuebusiform/W/hygl.hyapYtInfo.form_edit.vue?sysCode=' + this.$route.meta.sysCode
            this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfo.formTemplate)
            this.busiformBtns = []
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, row, 1, (res) => {
                    _this.autoCompute = true
                    this.getListData(this.vo, true)
                })
            })
        },
        delFn(row) {
            this.$confirm(this.$tx('hygl.message.delMeeting', '是否确认删除此议题'), this.$tx('common.confirmOperate', '确认操作'), {
                confirmButtonText: this.$tx('pageBtns.sure', '确定'),
                cancelButtonText: this.$tx('pageBtns.cancel', '取消'),
                type: 'warning'
            }).then(() => {
                this.$http({
                    method: 'delete',
                    url: '/hygl/hyapYtInfo/delete',
                    params: {
                        ids: row.id
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        this.autoCompute = true
                        this.$message.success(res.message)
                        this.getListData(this.vo, true)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            })
        },
        async openFn() {
            var flag = false
            console.log('this.wfInstance', this.wfInstance)

            if (!this.wfInstance.id || this.wfInstance.status < 1) {
                flag = true
            }
            this.isChange = false
            this.tableData = []
            this.autoCompute = false
            await this.getListData(this.vo, flag)
            this.$nextTick(() => {
                this.register()
            })
        },
        register() {
            const _this = this
            const tbody = document.querySelector('.draggable-table .el-table__body-wrapper tbody')
            new Sortable(tbody, {
                handle: '.handle', // handle's class
                animation: 150,
                // 需要在odEnd方法中处理原始eltable数据，使原始数据与显示数据保持顺序一致
                onEnd: ({ newIndex, oldIndex }) => {
                    this.isTableShow = false
                    console.log('newIndex', newIndex)
                    console.log('oldIndex', oldIndex)
                    const targetRow = this.tableData[oldIndex]
                    this.tableData.splice(oldIndex, 1)
                    this.tableData.splice(newIndex, 0, targetRow)
                    console.table(this.tableData)
                    _this.autoComputeTimes(this.tableData, this.vo.startTime, 0)
                    this.$nextTick(() => {
                        this.$forceUpdate()
                        this.isTableShow = true
                        this.$nextTick(() => {
                            _this.register()
                        })
                    })
                    this.isChange = true
                }
            })
        },
        getListData(vo, flag = false) {
            if (this.vo.status < 1) {
                this.vo.isMessage = 1
            }
            flag = true
            if (flag) {
                this.$http({
                    method: 'post',
                    url: '/hygl/hyapYtInfo/listdata',
                    params: {
                        pageSize: 9999,
                        pageNum: 1,
                        urlsearch: `hyapId:${vo.id}`,
                        orderBy: 'orderNo asc'
                    }
                }).then((res) => {
                    if (res.code === 'success') {
                        console.log('res', res)
                        const list = res.body.pageInfo.list
                        if (this.autoCompute) {
                            this.tableData = this.autoComputeTimes(list, this.vo.startTime, 0)
                            this.getAttendStoolName(this.tableData)
                        } else {
                            this.tableData = list
                            this.getAttendStoolName(this.tableData)
                        }
                    }
                })
            } else {
                const list = this.vo.passenger.hyapYtInfoList
                if (!list.length) {
                    this.tableData = []
                    return
                }
                if (this.autoCompute) {
                    this.tableData = this.autoComputeTimes(list, this.vo.startTime, 0)
                    this.getAttendStoolName(this.tableData)
                } else {
                    this.tableData = list
                    this.getAttendStoolName(this.tableData)
                }
            }
        },
        getAttendStoolName(list) {
            console.log('list', list)
            if (!list.length) {
                this.vo.sAttendName = this.vo.passenger.sAttendName ? this.vo.passenger.sAttendName.join('、') : ''
                this.vo.sAttendId = this.vo.passenger.sAttendId ? this.vo.passenger.sAttendId.join(',') : ''
                return
            }
            if (!this.wfInstance.id) return

            var nameTemp = []
            var nameIdTemp = []
            if (this.vo.sAttendName) {
                nameTemp = this.vo.sAttendName.split('、')
                nameIdTemp = this.vo.sAttendId.split(',')
            }
            var processed = {}
            var namesString = ''
            var idsString = ''
            list.forEach((item) => {
                var names = item.attendStoolName.split('、')
                names = nameTemp.concat(names)
                var ids = []
                if (item.attendStoolId) {
                    ids = item.attendStoolId.split(',')
                }
                ids = nameIdTemp.concat(ids)

                // 遍历每个名字
                names.forEach((name, index) => {
                    // 如果名字还没有被处理过，则添加到字符串中
                    if (!processed[name]) {
                        namesString += name + '、'
                        if (ids) {
                            idsString += ids[index] + ','
                        }
                        processed[name] = true // 标记名字已经被处理过
                    }
                })
            })
            namesString = namesString.slice(0, -1)
            idsString = idsString.slice(0, -1)

            this.vo.sAttendName = namesString
            this.vo.sAttendId = idsString
        },
        autoComputeTimes(list, time, startIndex = 0) {
            var defaultDate = new Date(time)
            var previousStartTime = ''
            var newStartTime = ''
            var newArr = list.map((item, index) => {
                // 如果是第一条数据，直接使用默认时间
                if (startIndex <= 0) {
                    if (index === 0) {
                        item.startTime = defaultDate
                    } else {
                        // 否则，根据前一条数据的startTime和reportTime计算当前startTime
                        previousStartTime = list[index - 1].startTime
                        newStartTime = new Date(new Date(previousStartTime).getTime() + list[index - 1].reportTime * 60 * 1000 + list[index - 1].talkTime * 60 * 1000)
                        item.startTime = moment(new Date(newStartTime)).format('YYYY-MM-DD HH:mm:ss')
                    }
                } else {
                    if (index > startIndex) {
                        if (index === 0) {
                            item.startTime = defaultDate
                        } else {
                            // 否则，根据前一条数据的startTime和reportTime计算当前startTime
                            previousStartTime = list[index - 1].startTime
                            newStartTime = new Date(new Date(previousStartTime).getTime() + list[index - 1].reportTime * 60 * 1000 + list[index - 1].talkTime * 60 * 1000)
                            item.startTime = moment(new Date(newStartTime)).format('YYYY-MM-DD HH:mm:ss')
                        }
                    }
                }
                return item
            }, [])
            return newArr
        },
        valueChange(ev, row, index) {
            this.autoCompute = true
            this.autoComputeTimes(this.tableData, ev, index)
        },
        timeFormat(val) {
            return val ? moment(new Date(val)).format('YYYY-MM-DD HH:mm') : ''
        }
    }
}
</script>

<style scoped lang="scss">
.handle {
    cursor: move;
    display: flex;
    align-content: center;
}
</style>
